<template>
  <v-multiselect
    :options="cultures"
    :value='$store.state.select.value'
    label='nom'
    @input='setActiveCulture'
    placeholder="Sélectionner une culture"
  >
    <template slot='noResult'>
      Aucune culture correspondante
    </template>
  </v-multiselect>
</template>

<script>
export default {
  name: 'SelectCulture',

  computed: {
    cultures () {
      return this.$store.state.referentiel.cultures
    }
  },

  methods: {
    setActiveCulture (culture) {
      this.$store.commit('select/SET_VALUE', culture)
    }
  }
}
</script>
